module.exports = __webpack_public_path__ + "static/media/Destinations.b0db6993.svg";